
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/liftkort",
      function () {
        return require("private-next-pages/[region]/[resort]/liftkort.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/liftkort"])
      });
    }
  